import { Dispatch, SetStateAction } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';

import { View } from './SearchPortal';

import classes from './searchPortal.module.css';

interface Props {
  query: string;
  setActiveView: Dispatch<SetStateAction<View>>;
  activeView: string;
}

const SearchPortalHeader = ({ query, activeView, setActiveView }: Props) => {
  const [, { navigate, backDestination }] = useNavigation();
  return (
    <div className={classes.searchPortalHeader}>
      <div className={classes.backContainer}>
        <IconButton onClick={() => navigate(backDestination())}>
          <Icon>arrow_back</Icon>
        </IconButton>
        <div>
          Search Results: <span className={classes.queryDisplay}>{query}</span>
        </div>
      </div>
      <div className={classes.navigationRow}>
        <div
          className={classes.tabContainer}
          onClick={() => setActiveView(View.ALL)}
          style={{
            color:
              activeView === View.ALL ? colors.brand.blue : colors.neutral.dark,
          }}
        >
          ALL RESULTS
        </div>
        <div
          className={classes.tabContainer}
          onClick={() => setActiveView(View.INVENTORY)}
          style={{
            color:
              activeView === View.INVENTORY
                ? colors.brand.blue
                : colors.neutral.dark,
          }}
        >
          INVENTORY
        </div>
        <div
          className={classes.tabContainer}
          onClick={() => setActiveView(View.WORK)}
          style={{
            color:
              activeView === View.WORK
                ? colors.brand.blue
                : colors.neutral.dark,
          }}
        >
          WORK
        </div>
        <div
          className={classes.tabContainer}
          onClick={() => setActiveView(View.USERS)}
          style={{
            color:
              activeView === View.USERS
                ? colors.brand.blue
                : colors.neutral.dark,
          }}
        >
          TEAM
        </div>
      </div>
    </div>
  );
};

export default SearchPortalHeader;
